import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Returns the user's current subscription plan ("free" | "basic" | "pro" |
 * "kennel_elite") so paywalled CTAs can flip labels from "$X" to
 * "Free with your plan" when the backend will waive the fee anyway.
 *
 * Why a hook (not context): the value is read by a handful of pages,
 * each of which is allowed to render before the network call resolves.
 * Caching is fine — `loading=true` during the fetch so callers can
 * show a neutral label until they know.
 *
 * Tiers that get unlimited free listing fees + free litter publishes:
 *   - "pro"
 *   - "kennel_elite"
 * Basic gets a per-month quota (handled server-side).
 */
export function useUserPlanTier() {
  const [tier, setTier] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    api.get("/billing/my-subscription")
      .then((r) => {
        if (!alive) return;
        setTier(r.data?.subscription?.plan || "free");
      })
      .catch(() => alive && setTier("free"))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);
  return {
    tier,
    loading,
    isProOrElite: tier === "pro" || tier === "kennel_elite",
    isElite: tier === "kennel_elite",
  };
}
